import http from '@/plugins/axios/axios';

export default class OcorrenciaService {

    salvar(requisicao) {       
        return http.post('/api/ocorrencia/salvar', requisicao);
    }

    alterar(requisicao) {       
        return http.post('/api/ocorrencia/alterar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/ocorrencia/excluir', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/ocorrencia/buscar', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/ocorrencia/listar', requisicao);
    } 
    
    buscarItemSolicitacao(requisicao) {       
        return http.post('/api/ocorrencia/buscar-item-solicitacao', requisicao);
    }
    
    resolverPendenciaNovo(requisicao) {       
        return http.post('/api/ocorrencia/resolver-pendencia-novo', requisicao);
    }

    resolverPendenciaAlteracao(requisicao) {       
        return http.post('/api/ocorrencia/resolver-pendencia-alterar', requisicao);
    }

    resolverPendenciaExcluir(requisicao) {       
        return http.post('/api/ocorrencia/resolver-pendencia-excluir', requisicao);
    }
}